export const GET_JOB_BRIEFING_REQUEST = "GET_JOB_BRIEFING_REQUEST";
export const GET_JOB_BRIEFING_SUCCESS = "GET_JOB_BRIEFING_SUCCESS";
export const GET_JOB_BRIEFING_FAILURE = "GET_JOB_BRIEFING_FAILURE";

export const RESET_JOB_BRIEFING = "RESET_JOB_BRIEFING";
